import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics';
import { FaLock } from 'react-icons/fa';
import { getAaveV3Tokens } from '../../allowanceRequiredProtocols';
import { POOL_ADDRESSES } from '../constants';
export var SetUserUseReserveAsCollateral = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'setUserUseReserveAsCollateral',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }), isPreview: true, icon: FaLock }),
                    useAsCollateral: new FctBoolean({ isPreview: true }),
                },
            },
            output: {},
        });
    },
});
